
import { format } from '@ms/utilities-strings/lib/index';
import {
    getRelativeDateTimeResx,
    getRelativeDateTimeIntervalString
} from './relativePast';
import DateTimeResx from './DateTime.resx';

/**
 * For use with lists' server-processed date value.
 * @param relativeDateTimeJSString list server-processed date value string
 * @param startWithLowerCase use this option when the return string is not at beginning of the sentence.
 */
export function getRelativeDateTimeStringForLists(relativeDateTimeJSString: string, startWithLowerCase: boolean = false): string | null {
    let codes = relativeDateTimeJSString.split('|');

    // Passthrough case
    if (codes[0] === '0') {
        return relativeDateTimeJSString.substring(2);
    }

    let isFuture = codes[1] === '1';
    let timeBucket = codes[2];
    let timeValue = codes[3] || '';
    let timeValue2 = codes[4] || '';

    switch (timeBucket) {
        // a few seconds
        case '1':
            return getRelativeDateTimeResx('AFewSeconds', startWithLowerCase, isFuture);

        // about a minute
        case '2':
            return getRelativeDateTimeResx('AboutAMinute', startWithLowerCase, isFuture);

        // x minutes
        case '3':
            return getRelativeDateTimeIntervalString(Number(timeValue), 'XMinutes', startWithLowerCase, isFuture);

        // about an hour
        case '4':
            return getRelativeDateTimeResx('AboutAnHour', startWithLowerCase, isFuture);

        // yesterday / tomorrow
        case '5':
            if (!timeValue) {
                return getRelativeDateTimeResx(isFuture ? 'Tomorrow' : 'Yesterday', startWithLowerCase);
            }
            return format(
                getRelativeDateTimeResx(isFuture ? 'TomorrowAndTime' : 'YesterdayAndTime', startWithLowerCase),
                timeValue);

        // x hours
        case '6':
            return getRelativeDateTimeIntervalString(Number(timeValue), 'XHours', startWithLowerCase, isFuture);

        // day and time
        case '7':
            if (timeValue2) {
                return format(DateTimeResx.RelativeDateTime_DayAndTime, timeValue, timeValue2);
            }
            return timeValue;

        // <Days> days
        case '8':
            return getRelativeDateTimeIntervalString(Number(timeValue), 'XDays', startWithLowerCase, isFuture);

        // today
        case '9':
            return getRelativeDateTimeResx('Today', startWithLowerCase);
    }

    return null;
}
